var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarContour = function SvgStarContour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 42.058 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.029 0 6.5 13.167 14.531 2.111-10.517 10.253 2.482 14.472-13-6.833-13 6.833 2.491-14.472L.001 15.282l14.531-2.111Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m21.029 2.26-5.602 11.35-.233.471-.52.076-12.525 1.82 9.063 8.835.377.367-.09.518L9.36 38.172l11.203-5.89.466-.245.465.245 11.203 5.89-2.14-12.475-.088-.518.376-.367 9.064-8.835-12.526-1.82-.52-.076-.233-.471L21.03 2.26m0-2.26 6.498 13.167 14.531 2.112-10.515 10.249L34.026 40l-12.997-6.833L8.032 40l2.482-14.472L0 15.278l14.53-2.11L21.03 0Z"
  }))));
};
export default SvgStarContour;